const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-rbac/role.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { RoleListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-rbac/role-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-rbac/role')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: RoleListFilterParamSchema
});